import React, { useEffect, useRef } from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  className = "max-w-md",
  footer,
}) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Ignore clicks inside Google Places autocomplete dropdown (.pac-container)
      if (event.target.closest(".pac-container")) return;

      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  if (footer) {
    return (
      <div
        className="custom-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
        style={{ zIndex: 99999, margin: "0 !important" }}
      >
        <div
          ref={modalRef}
          className={`relative flex max-h-[92vh] w-full flex-col rounded bg-white ${className}`}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-darkergray"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
          {title && (
            <div className="shrink-0 px-6 pt-6">
              <h4 className="w-full text-center">{title}</h4>
            </div>
          )}
          <div className="mt-4 min-h-0 flex-1 space-y-4 overflow-y-auto px-6 pb-6">
            {children}
          </div>
          <div className="shrink-0 border-t border-mediumgray px-6 py-4">
            {footer}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="custom-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
      style={{ zIndex: 99999, margin: "0 !important" }}
    >
      <div
        ref={modalRef}
        className={`my-4 bg-white rounded p-6 w-full max-h-[600px] overflow-y-auto relative ${className} `}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-darkergray"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
        {title && <h4 className="w-full text-center">{title}</h4>}
        <div className="mt-4 space-y-4">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
